export enum UserRole {
  ADVISORY = 'ADVISORY',
  BANKER = 'BANKER',
  CREDIT_TEAM = 'CREDIT_TEAM',
  BANKER_ASSISTANT = 'BANKER_ASSISTANT',
  FINANCE = 'FINANCE',
  INVESTMENT_SOLUTIONS = 'INVESTMENT_SOLUTIONS',
  MARKET_HEAD = 'MARKET_HEAD',
  SENIOR_MANAGER = 'SENIOR_MANAGER',
  TASK_APPROVER = 'TASK_APPROVER',
  TEAM_HEAD = 'TEAM_HEAD',
  SALES_MANAGEMENT = 'SALES_MANAGEMENT',
  PHAROS_LABS_FEATURE_FLAG = 'PHAROS_LABS_FEATURE_FLAG',
  OUTBOUND = 'OUTBOUND',
}

export const allUserRoles = Object.keys(UserRole);

export const mainRoles = [UserRole.BANKER, UserRole.OUTBOUND];
